"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultHostConfig = exports.HostConfig = exports.CarouselConfig = exports.FontTypeSet = exports.FontTypeDefinition = exports.ContainerStyleSet = exports.ContainerStyleDefinition = exports.ColorSetDefinition = exports.ActionsConfig = exports.ShowCardActionConfig = exports.FactSetConfig = exports.FactTitleDefinition = exports.FactTextDefinition = exports.InputConfig = exports.InputLabelConfig = exports.RequiredInputLabelTextDefinition = exports.TextBlockConfig = exports.TextStyleSet = exports.TextStyleDefinition = exports.BaseTextDefinition = exports.TableConfig = exports.MediaConfig = exports.ImageSetConfig = exports.AdaptiveCardConfig = exports.TextColorDefinition = exports.ColorDefinition = void 0;
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
var Enums = require("./enums");
var Utils = require("./utils");
var Shared = require("./shared");
var host_capabilities_1 = require("./host-capabilities");
function parseHostConfigEnum(targetEnum, value, defaultValue) {
  if (typeof value === "string") {
    var parsedValue = Utils.parseEnum(targetEnum, value, defaultValue);
    return parsedValue !== undefined ? parsedValue : defaultValue;
  } else if (typeof value === "number") {
    return value;
  } else {
    return defaultValue;
  }
}
var ColorDefinition = /** @class */function () {
  function ColorDefinition(defaultColor, subtleColor) {
    this.default = "#000000";
    this.subtle = "#666666";
    if (defaultColor) {
      this.default = defaultColor;
    }
    if (subtleColor) {
      this.subtle = subtleColor;
    }
  }
  ColorDefinition.prototype.parse = function (obj) {
    if (obj) {
      this.default = obj["default"] || this.default;
      this.subtle = obj["subtle"] || this.subtle;
    }
  };
  return ColorDefinition;
}();
exports.ColorDefinition = ColorDefinition;
var TextColorDefinition = /** @class */function (_super) {
  __extends(TextColorDefinition, _super);
  function TextColorDefinition() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.highlightColors = new ColorDefinition("#22000000", "#11000000");
    return _this;
  }
  TextColorDefinition.prototype.parse = function (obj) {
    _super.prototype.parse.call(this, obj);
    if (obj) {
      this.highlightColors.parse(obj["highlightColors"]);
    }
  };
  return TextColorDefinition;
}(ColorDefinition);
exports.TextColorDefinition = TextColorDefinition;
var AdaptiveCardConfig = /** @class */function () {
  function AdaptiveCardConfig(obj) {
    this.allowCustomStyle = false;
    if (obj) {
      this.allowCustomStyle = obj["allowCustomStyle"] || this.allowCustomStyle;
    }
  }
  return AdaptiveCardConfig;
}();
exports.AdaptiveCardConfig = AdaptiveCardConfig;
var ImageSetConfig = /** @class */function () {
  function ImageSetConfig(obj) {
    this.imageSize = Enums.Size.Medium;
    this.maxImageHeight = 100;
    if (obj) {
      this.imageSize = obj["imageSize"] != null ? obj["imageSize"] : this.imageSize;
      this.maxImageHeight = Utils.parseNumber(obj["maxImageHeight"], 100);
    }
  }
  ImageSetConfig.prototype.toJSON = function () {
    return {
      imageSize: Enums.Size[this.imageSize],
      maxImageHeight: this.maxImageHeight
    };
  };
  return ImageSetConfig;
}();
exports.ImageSetConfig = ImageSetConfig;
var MediaConfig = /** @class */function () {
  function MediaConfig(obj) {
    this.allowInlinePlayback = true;
    if (obj) {
      this.defaultPoster = obj["defaultPoster"];
      this.allowInlinePlayback = obj["allowInlinePlayback"] || this.allowInlinePlayback;
    }
  }
  MediaConfig.prototype.toJSON = function () {
    return {
      defaultPoster: this.defaultPoster,
      allowInlinePlayback: this.allowInlinePlayback
    };
  };
  return MediaConfig;
}();
exports.MediaConfig = MediaConfig;
var TableConfig = /** @class */function () {
  function TableConfig(obj) {
    this.cellSpacing = 8;
    if (obj) {
      this.cellSpacing = obj.cellSpacing && typeof obj.cellSpacing === "number" ? obj.cellSpacing : this.cellSpacing;
    }
  }
  TableConfig.prototype.toJSON = function () {
    return {
      cellSpacing: this.cellSpacing
    };
  };
  return TableConfig;
}();
exports.TableConfig = TableConfig;
var BaseTextDefinition = /** @class */function () {
  function BaseTextDefinition(obj) {
    this.size = Enums.TextSize.Default;
    this.color = Enums.TextColor.Default;
    this.isSubtle = false;
    this.weight = Enums.TextWeight.Default;
    this.parse(obj);
  }
  BaseTextDefinition.prototype.parse = function (obj) {
    if (obj) {
      this.size = parseHostConfigEnum(Enums.TextSize, obj["size"], this.size);
      this.color = parseHostConfigEnum(Enums.TextColor, obj["color"], this.color);
      this.isSubtle = obj.isSubtle !== undefined && typeof obj.isSubtle === "boolean" ? obj.isSubtle : this.isSubtle;
      this.weight = parseHostConfigEnum(Enums.TextWeight, obj["weight"], this.getDefaultWeight());
    }
  };
  BaseTextDefinition.prototype.getDefaultWeight = function () {
    return Enums.TextWeight.Default;
  };
  BaseTextDefinition.prototype.toJSON = function () {
    return {
      size: Enums.TextSize[this.size],
      color: Enums.TextColor[this.color],
      isSubtle: this.isSubtle,
      weight: Enums.TextWeight[this.weight]
    };
  };
  return BaseTextDefinition;
}();
exports.BaseTextDefinition = BaseTextDefinition;
var TextStyleDefinition = /** @class */function (_super) {
  __extends(TextStyleDefinition, _super);
  function TextStyleDefinition() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.fontType = Enums.FontType.Default;
    return _this;
  }
  TextStyleDefinition.prototype.parse = function (obj) {
    _super.prototype.parse.call(this, obj);
    if (obj) {
      this.fontType = parseHostConfigEnum(Enums.FontType, obj.fontType, this.fontType);
    }
  };
  return TextStyleDefinition;
}(BaseTextDefinition);
exports.TextStyleDefinition = TextStyleDefinition;
var TextStyleSet = /** @class */function () {
  function TextStyleSet(obj) {
    this.default = new TextStyleDefinition();
    this.heading = new TextStyleDefinition({
      size: "Large",
      weight: "Bolder"
    });
    this.columnHeader = new TextStyleDefinition({
      weight: "Bolder"
    });
    if (obj) {
      this.heading.parse(obj.heading);
      this.columnHeader.parse(obj.columnHeader);
    }
  }
  TextStyleSet.prototype.getStyleByName = function (name) {
    switch (name.toLowerCase()) {
      case "heading":
        return this.heading;
      case "columnHeader":
        return this.columnHeader;
      default:
        return this.default;
    }
  };
  return TextStyleSet;
}();
exports.TextStyleSet = TextStyleSet;
var TextBlockConfig = /** @class */function () {
  function TextBlockConfig(obj) {
    if (obj) {
      this.headingLevel = Utils.parseNumber(obj.headingLevel);
    }
  }
  return TextBlockConfig;
}();
exports.TextBlockConfig = TextBlockConfig;
var RequiredInputLabelTextDefinition = /** @class */function (_super) {
  __extends(RequiredInputLabelTextDefinition, _super);
  function RequiredInputLabelTextDefinition() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.suffix = " *";
    _this.suffixColor = Enums.TextColor.Attention;
    return _this;
  }
  RequiredInputLabelTextDefinition.prototype.parse = function (obj) {
    _super.prototype.parse.call(this, obj);
    if (obj) {
      this.suffix = obj["suffix"] || this.suffix;
      this.suffixColor = parseHostConfigEnum(Enums.TextColor, obj["suffixColor"], this.suffixColor);
    }
  };
  RequiredInputLabelTextDefinition.prototype.toJSON = function () {
    var result = _super.prototype.toJSON.call(this);
    result["suffix"] = this.suffix;
    result["suffixColor"] = Enums.TextColor[this.suffixColor];
    return result;
  };
  return RequiredInputLabelTextDefinition;
}(BaseTextDefinition);
exports.RequiredInputLabelTextDefinition = RequiredInputLabelTextDefinition;
var InputLabelConfig = /** @class */function () {
  function InputLabelConfig(obj) {
    this.inputSpacing = Enums.Spacing.Small;
    this.width = 30;
    this.requiredInputs = new RequiredInputLabelTextDefinition();
    this.optionalInputs = new BaseTextDefinition();
    if (obj) {
      this.inputSpacing = parseHostConfigEnum(Enums.Spacing, obj["inputSpacing"], this.inputSpacing);
      this.requiredInputs = new RequiredInputLabelTextDefinition(obj["requiredInputs"]);
      this.optionalInputs = new BaseTextDefinition(obj["optionalInputs"]);
      this.width = obj["width"] != null ? obj["width"] : this.width;
    }
  }
  return InputLabelConfig;
}();
exports.InputLabelConfig = InputLabelConfig;
var InputConfig = /** @class */function () {
  function InputConfig(obj) {
    this.label = new InputLabelConfig();
    this.errorMessage = new BaseTextDefinition({
      color: Enums.TextColor.Attention
    });
    this.debounceTimeInMilliSeconds = 0;
    this.allowDynamicallyFilteredChoiceSet = true;
    this.allowRevealOnHoverStyle = false;
    if (obj) {
      this.label = new InputLabelConfig(obj["label"]);
      this.errorMessage = new BaseTextDefinition(obj["errorMessage"]);
      this.allowRevealOnHoverStyle = obj["allowRevealOnHoverStyle"] || this.allowRevealOnHoverStyle;
      this.allowDynamicallyFilteredChoiceSet = obj["allowDynamicallyFilteredChoiceSet"] || this.allowDynamicallyFilteredChoiceSet;
      this.debounceTimeInMilliSeconds = obj["debounceTimeInMilliSeconds"] || this.debounceTimeInMilliSeconds;
    }
  }
  return InputConfig;
}();
exports.InputConfig = InputConfig;
var FactTextDefinition = /** @class */function (_super) {
  __extends(FactTextDefinition, _super);
  function FactTextDefinition() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.wrap = true;
    return _this;
  }
  FactTextDefinition.prototype.parse = function (obj) {
    _super.prototype.parse.call(this, obj);
    if (obj) {
      this.wrap = obj["wrap"] != null ? obj["wrap"] : this.wrap;
    }
  };
  FactTextDefinition.prototype.toJSON = function () {
    var result = _super.prototype.toJSON.call(this);
    result["wrap"] = this.wrap;
    return result;
  };
  return FactTextDefinition;
}(BaseTextDefinition);
exports.FactTextDefinition = FactTextDefinition;
var FactTitleDefinition = /** @class */function (_super) {
  __extends(FactTitleDefinition, _super);
  function FactTitleDefinition(obj) {
    var _this = _super.call(this, obj) || this;
    _this.maxWidth = 150;
    _this.weight = Enums.TextWeight.Bolder;
    if (obj) {
      _this.maxWidth = obj["maxWidth"] != null ? obj["maxWidth"] : _this.maxWidth;
      _this.weight = parseHostConfigEnum(Enums.TextWeight, obj["weight"], Enums.TextWeight.Bolder);
    }
    return _this;
  }
  FactTitleDefinition.prototype.getDefaultWeight = function () {
    return Enums.TextWeight.Bolder;
  };
  return FactTitleDefinition;
}(FactTextDefinition);
exports.FactTitleDefinition = FactTitleDefinition;
var FactSetConfig = /** @class */function () {
  function FactSetConfig(obj) {
    this.title = new FactTitleDefinition();
    this.value = new FactTextDefinition();
    this.spacing = 10;
    if (obj) {
      this.title = new FactTitleDefinition(obj["title"]);
      this.value = new FactTextDefinition(obj["value"]);
      this.spacing = obj.spacing && obj.spacing != null ? obj.spacing && obj.spacing : this.spacing;
    }
  }
  return FactSetConfig;
}();
exports.FactSetConfig = FactSetConfig;
var ShowCardActionConfig = /** @class */function () {
  function ShowCardActionConfig(obj) {
    this.actionMode = Enums.ShowCardActionMode.Inline;
    this.inlineTopMargin = 16;
    this.style = Enums.ContainerStyle.Emphasis;
    if (obj) {
      this.actionMode = parseHostConfigEnum(Enums.ShowCardActionMode, obj["actionMode"], Enums.ShowCardActionMode.Inline);
      this.inlineTopMargin = obj["inlineTopMargin"] != null ? obj["inlineTopMargin"] : this.inlineTopMargin;
      this.style = obj["style"] && typeof obj["style"] === "string" ? obj["style"] : Enums.ContainerStyle.Emphasis;
    }
  }
  ShowCardActionConfig.prototype.toJSON = function () {
    return {
      actionMode: Enums.ShowCardActionMode[this.actionMode],
      inlineTopMargin: this.inlineTopMargin,
      style: this.style
    };
  };
  return ShowCardActionConfig;
}();
exports.ShowCardActionConfig = ShowCardActionConfig;
var ActionsConfig = /** @class */function () {
  function ActionsConfig(obj) {
    this.maxActions = 5;
    this.spacing = Enums.Spacing.Default;
    this.buttonSpacing = 20;
    this.showCard = new ShowCardActionConfig();
    this.preExpandSingleShowCardAction = false;
    this.actionsOrientation = Enums.Orientation.Horizontal;
    this.actionAlignment = Enums.ActionAlignment.Left;
    this.iconPlacement = Enums.ActionIconPlacement.LeftOfTitle;
    this.allowTitleToWrap = false;
    this.iconSize = 16;
    if (obj) {
      this.maxActions = obj["maxActions"] != null ? obj["maxActions"] : this.maxActions;
      this.spacing = parseHostConfigEnum(Enums.Spacing, obj.spacing && obj.spacing, Enums.Spacing.Default);
      this.buttonSpacing = obj["buttonSpacing"] != null ? obj["buttonSpacing"] : this.buttonSpacing;
      this.showCard = new ShowCardActionConfig(obj["showCard"]);
      this.preExpandSingleShowCardAction = Utils.parseBool(obj["preExpandSingleShowCardAction"], false);
      this.actionsOrientation = parseHostConfigEnum(Enums.Orientation, obj["actionsOrientation"], Enums.Orientation.Horizontal);
      this.actionAlignment = parseHostConfigEnum(Enums.ActionAlignment, obj["actionAlignment"], Enums.ActionAlignment.Left);
      this.iconPlacement = parseHostConfigEnum(Enums.ActionIconPlacement, obj["iconPlacement"], Enums.ActionIconPlacement.LeftOfTitle);
      this.allowTitleToWrap = obj["allowTitleToWrap"] != null ? obj["allowTitleToWrap"] : this.allowTitleToWrap;
      try {
        var sizeAndUnit = Shared.SizeAndUnit.parse(obj["iconSize"]);
        if (sizeAndUnit.unit === Enums.SizeUnit.Pixel) {
          this.iconSize = sizeAndUnit.physicalSize;
        }
      } catch (e) {
        // Swallow this, keep default icon size
      }
    }
  }
  ActionsConfig.prototype.toJSON = function () {
    return {
      maxActions: this.maxActions,
      spacing: Enums.Spacing[this.spacing],
      buttonSpacing: this.buttonSpacing,
      showCard: this.showCard,
      preExpandSingleShowCardAction: this.preExpandSingleShowCardAction,
      actionsOrientation: Enums.Orientation[this.actionsOrientation],
      actionAlignment: Enums.ActionAlignment[this.actionAlignment]
    };
  };
  return ActionsConfig;
}();
exports.ActionsConfig = ActionsConfig;
var ColorSetDefinition = /** @class */function () {
  function ColorSetDefinition(obj) {
    this.default = new TextColorDefinition();
    this.dark = new TextColorDefinition();
    this.light = new TextColorDefinition();
    this.accent = new TextColorDefinition();
    this.good = new TextColorDefinition();
    this.warning = new TextColorDefinition();
    this.attention = new TextColorDefinition();
    this.parse(obj);
  }
  ColorSetDefinition.prototype.parseSingleColor = function (obj, propertyName) {
    if (obj) {
      this[propertyName].parse(obj[propertyName]);
    }
  };
  ColorSetDefinition.prototype.parse = function (obj) {
    if (obj) {
      this.parseSingleColor(obj, "default");
      this.parseSingleColor(obj, "dark");
      this.parseSingleColor(obj, "light");
      this.parseSingleColor(obj, "accent");
      this.parseSingleColor(obj, "good");
      this.parseSingleColor(obj, "warning");
      this.parseSingleColor(obj, "attention");
    }
  };
  return ColorSetDefinition;
}();
exports.ColorSetDefinition = ColorSetDefinition;
var ContainerStyleDefinition = /** @class */function () {
  function ContainerStyleDefinition(obj) {
    this.foregroundColors = new ColorSetDefinition({
      "default": {
        default: "#333333",
        subtle: "#EE333333"
      },
      "dark": {
        default: "#000000",
        subtle: "#66000000"
      },
      "light": {
        default: "#FFFFFF",
        subtle: "#33000000"
      },
      "accent": {
        default: "#2E89FC",
        subtle: "#882E89FC"
      },
      "good": {
        default: "#028A02",
        subtle: "#DD027502"
      },
      "warning": {
        default: "#E69500",
        subtle: "#DDE69500"
      },
      "attention": {
        default: "#CC3300",
        subtle: "#DDCC3300"
      }
    });
    this.parse(obj);
  }
  ContainerStyleDefinition.prototype.parse = function (obj) {
    if (obj) {
      this.backgroundColor = obj["backgroundColor"];
      this.foregroundColors.parse(obj["foregroundColors"]);
      this.highlightBackgroundColor = obj["highlightBackgroundColor"];
      this.highlightForegroundColor = obj["highlightForegroundColor"];
      this.borderColor = obj["borderColor"];
    }
  };
  Object.defineProperty(ContainerStyleDefinition.prototype, "isBuiltIn", {
    get: function () {
      return false;
    },
    enumerable: false,
    configurable: true
  });
  return ContainerStyleDefinition;
}();
exports.ContainerStyleDefinition = ContainerStyleDefinition;
var BuiltInContainerStyleDefinition = /** @class */function (_super) {
  __extends(BuiltInContainerStyleDefinition, _super);
  function BuiltInContainerStyleDefinition() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(BuiltInContainerStyleDefinition.prototype, "isBuiltIn", {
    get: function () {
      return true;
    },
    enumerable: false,
    configurable: true
  });
  return BuiltInContainerStyleDefinition;
}(ContainerStyleDefinition);
var ContainerStyleSet = /** @class */function () {
  function ContainerStyleSet(obj) {
    this._allStyles = {};
    this._allStyles[Enums.ContainerStyle.Default] = new BuiltInContainerStyleDefinition();
    this._allStyles[Enums.ContainerStyle.Emphasis] = new BuiltInContainerStyleDefinition();
    this._allStyles[Enums.ContainerStyle.Accent] = new BuiltInContainerStyleDefinition();
    this._allStyles[Enums.ContainerStyle.Good] = new BuiltInContainerStyleDefinition();
    this._allStyles[Enums.ContainerStyle.Attention] = new BuiltInContainerStyleDefinition();
    this._allStyles[Enums.ContainerStyle.Warning] = new BuiltInContainerStyleDefinition();
    if (obj) {
      this._allStyles[Enums.ContainerStyle.Default].parse(obj[Enums.ContainerStyle.Default]);
      this._allStyles[Enums.ContainerStyle.Emphasis].parse(obj[Enums.ContainerStyle.Emphasis]);
      this._allStyles[Enums.ContainerStyle.Accent].parse(obj[Enums.ContainerStyle.Accent]);
      this._allStyles[Enums.ContainerStyle.Good].parse(obj[Enums.ContainerStyle.Good]);
      this._allStyles[Enums.ContainerStyle.Attention].parse(obj[Enums.ContainerStyle.Attention]);
      this._allStyles[Enums.ContainerStyle.Warning].parse(obj[Enums.ContainerStyle.Warning]);
      var customStyleArray = obj["customStyles"];
      if (customStyleArray && Array.isArray(customStyleArray)) {
        for (var _i = 0, customStyleArray_1 = customStyleArray; _i < customStyleArray_1.length; _i++) {
          var customStyle = customStyleArray_1[_i];
          if (customStyle) {
            var styleName = customStyle["name"];
            if (styleName && typeof styleName === "string") {
              if (this._allStyles.hasOwnProperty(styleName)) {
                this._allStyles[styleName].parse(customStyle["style"]);
              } else {
                this._allStyles[styleName] = new ContainerStyleDefinition(customStyle["style"]);
              }
            }
          }
        }
      }
    }
  }
  ContainerStyleSet.prototype.toJSON = function () {
    var _this = this;
    var customStyleArray = [];
    Object.keys(this._allStyles).forEach(function (key) {
      if (!_this._allStyles[key].isBuiltIn) {
        customStyleArray.push({
          name: key,
          style: _this._allStyles[key]
        });
      }
    });
    var result = {
      default: this.default,
      emphasis: this.emphasis
    };
    if (customStyleArray.length > 0) {
      result.customStyles = customStyleArray;
    }
    return result;
  };
  ContainerStyleSet.prototype.getStyleByName = function (name, defaultValue) {
    if (name && this._allStyles.hasOwnProperty(name)) {
      return this._allStyles[name];
    } else {
      return defaultValue ? defaultValue : this._allStyles[Enums.ContainerStyle.Default];
    }
  };
  Object.defineProperty(ContainerStyleSet.prototype, "default", {
    get: function () {
      return this._allStyles[Enums.ContainerStyle.Default];
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ContainerStyleSet.prototype, "emphasis", {
    get: function () {
      return this._allStyles[Enums.ContainerStyle.Emphasis];
    },
    enumerable: false,
    configurable: true
  });
  return ContainerStyleSet;
}();
exports.ContainerStyleSet = ContainerStyleSet;
var FontTypeDefinition = /** @class */function () {
  function FontTypeDefinition(fontFamily) {
    this.fontFamily = "Segoe UI,Segoe,Segoe WP,Helvetica Neue,Helvetica,sans-serif";
    this.fontSizes = {
      small: 12,
      default: 14,
      medium: 17,
      large: 21,
      extraLarge: 26
    };
    this.fontWeights = {
      lighter: 200,
      default: 400,
      bolder: 600
    };
    if (fontFamily) {
      this.fontFamily = fontFamily;
    }
  }
  FontTypeDefinition.prototype.parse = function (obj) {
    this.fontFamily = obj["fontFamily"] || this.fontFamily;
    this.fontSizes = {
      small: obj.fontSizes && obj.fontSizes["small"] || this.fontSizes.small,
      default: obj.fontSizes && obj.fontSizes["default"] || this.fontSizes.default,
      medium: obj.fontSizes && obj.fontSizes["medium"] || this.fontSizes.medium,
      large: obj.fontSizes && obj.fontSizes["large"] || this.fontSizes.large,
      extraLarge: obj.fontSizes && obj.fontSizes["extraLarge"] || this.fontSizes.extraLarge
    };
    this.fontWeights = {
      lighter: obj.fontWeights && obj.fontWeights["lighter"] || this.fontWeights.lighter,
      default: obj.fontWeights && obj.fontWeights["default"] || this.fontWeights.default,
      bolder: obj.fontWeights && obj.fontWeights["bolder"] || this.fontWeights.bolder
    };
  };
  FontTypeDefinition.monospace = new FontTypeDefinition("'Courier New', Courier, monospace");
  return FontTypeDefinition;
}();
exports.FontTypeDefinition = FontTypeDefinition;
var FontTypeSet = /** @class */function () {
  function FontTypeSet(obj) {
    this.default = new FontTypeDefinition();
    this.monospace = new FontTypeDefinition("'Courier New', Courier, monospace");
    if (obj) {
      this.default.parse(obj["default"]);
      this.monospace.parse(obj["monospace"]);
    }
  }
  FontTypeSet.prototype.getStyleDefinition = function (style) {
    switch (style) {
      case Enums.FontType.Monospace:
        return this.monospace;
      case Enums.FontType.Default:
      default:
        return this.default;
    }
  };
  return FontTypeSet;
}();
exports.FontTypeSet = FontTypeSet;
var CarouselConfig = /** @class */function () {
  function CarouselConfig(obj) {
    this.maxCarouselPages = 10;
    this.minAutoplayDelay = 5000.0;
    if (obj) {
      this.maxCarouselPages = obj["maxCarouselPages"] != null ? obj["maxCarouselPages"] : this.maxCarouselPages;
      this.minAutoplayDelay = obj["minAutoplayDelay"] != null ? obj["minAutoplayDelay"] : this.minAutoplayDelay;
    }
  }
  CarouselConfig.prototype.toJSON = function () {
    return {
      maxCarouselPages: this.maxCarouselPages,
      minAutoplayDelay: this.minAutoplayDelay
    };
  };
  return CarouselConfig;
}();
exports.CarouselConfig = CarouselConfig;
var HostConfig = /** @class */function () {
  function HostConfig(obj) {
    this.hostCapabilities = new host_capabilities_1.HostCapabilities();
    this.choiceSetInputValueSeparator = ",";
    this.supportsInteractivity = true;
    this.spacing = {
      small: 3,
      default: 8,
      medium: 20,
      large: 30,
      extraLarge: 40,
      padding: 15
    };
    this.separator = {
      lineThickness: 1,
      lineColor: "#EEEEEE"
    };
    this.imageSizes = {
      small: 40,
      medium: 80,
      large: 160
    };
    this.containerStyles = new ContainerStyleSet();
    this.inputs = new InputConfig();
    this.actions = new ActionsConfig();
    this.adaptiveCard = new AdaptiveCardConfig();
    this.imageSet = new ImageSetConfig();
    this.media = new MediaConfig();
    this.factSet = new FactSetConfig();
    this.table = new TableConfig();
    this.textStyles = new TextStyleSet();
    this.textBlock = new TextBlockConfig();
    this.carousel = new CarouselConfig();
    this.alwaysAllowBleed = false;
    if (obj) {
      if (typeof obj === "string" || obj instanceof String) {
        obj = JSON.parse(obj);
      }
      this.choiceSetInputValueSeparator = obj && typeof obj["choiceSetInputValueSeparator"] === "string" ? obj["choiceSetInputValueSeparator"] : this.choiceSetInputValueSeparator;
      this.supportsInteractivity = obj && typeof obj["supportsInteractivity"] === "boolean" ? obj["supportsInteractivity"] : this.supportsInteractivity;
      this._legacyFontType = new FontTypeDefinition();
      this._legacyFontType.parse(obj);
      if (obj.fontTypes) {
        this.fontTypes = new FontTypeSet(obj.fontTypes);
      }
      if (obj.lineHeights) {
        this.lineHeights = {
          small: obj.lineHeights["small"],
          default: obj.lineHeights["default"],
          medium: obj.lineHeights["medium"],
          large: obj.lineHeights["large"],
          extraLarge: obj.lineHeights["extraLarge"]
        };
      }
      this.imageSizes = {
        small: obj.imageSizes && obj.imageSizes["small"] || this.imageSizes.small,
        medium: obj.imageSizes && obj.imageSizes["medium"] || this.imageSizes.medium,
        large: obj.imageSizes && obj.imageSizes["large"] || this.imageSizes.large
      };
      this.containerStyles = new ContainerStyleSet(obj["containerStyles"]);
      this.spacing = {
        small: obj.spacing && obj.spacing["small"] || this.spacing.small,
        default: obj.spacing && obj.spacing["default"] || this.spacing.default,
        medium: obj.spacing && obj.spacing["medium"] || this.spacing.medium,
        large: obj.spacing && obj.spacing["large"] || this.spacing.large,
        extraLarge: obj.spacing && obj.spacing["extraLarge"] || this.spacing.extraLarge,
        padding: obj.spacing && obj.spacing["padding"] || this.spacing.padding
      };
      this.separator = {
        lineThickness: obj.separator && obj.separator["lineThickness"] || this.separator.lineThickness,
        lineColor: obj.separator && obj.separator["lineColor"] || this.separator.lineColor
      };
      this.inputs = new InputConfig(obj.inputs || this.inputs);
      this.actions = new ActionsConfig(obj.actions || this.actions);
      this.adaptiveCard = new AdaptiveCardConfig(obj.adaptiveCard || this.adaptiveCard);
      this.imageSet = new ImageSetConfig(obj["imageSet"]);
      this.factSet = new FactSetConfig(obj["factSet"]);
      this.textStyles = new TextStyleSet(obj["textStyles"]);
      this.textBlock = new TextBlockConfig(obj["textBlock"]);
      this.carousel = new CarouselConfig(obj["carousel"]);
    }
  }
  HostConfig.prototype.getFontTypeDefinition = function (style) {
    if (this.fontTypes) {
      return this.fontTypes.getStyleDefinition(style);
    } else {
      return style === Enums.FontType.Monospace ? FontTypeDefinition.monospace : this._legacyFontType;
    }
  };
  HostConfig.prototype.getEffectiveSpacing = function (spacing) {
    switch (spacing) {
      case Enums.Spacing.Small:
        return this.spacing.small;
      case Enums.Spacing.Default:
        return this.spacing.default;
      case Enums.Spacing.Medium:
        return this.spacing.medium;
      case Enums.Spacing.Large:
        return this.spacing.large;
      case Enums.Spacing.ExtraLarge:
        return this.spacing.extraLarge;
      case Enums.Spacing.Padding:
        return this.spacing.padding;
      default:
        return 0;
    }
  };
  HostConfig.prototype.paddingDefinitionToSpacingDefinition = function (paddingDefinition) {
    return new Shared.SpacingDefinition(this.getEffectiveSpacing(paddingDefinition.top), this.getEffectiveSpacing(paddingDefinition.right), this.getEffectiveSpacing(paddingDefinition.bottom), this.getEffectiveSpacing(paddingDefinition.left));
  };
  HostConfig.prototype.makeCssClassNames = function () {
    var classNames = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      classNames[_i] = arguments[_i];
    }
    var result = [];
    for (var _a = 0, classNames_1 = classNames; _a < classNames_1.length; _a++) {
      var className = classNames_1[_a];
      result.push((this.cssClassNamePrefix ? this.cssClassNamePrefix + "-" : "") + className);
    }
    return result;
  };
  HostConfig.prototype.makeCssClassName = function () {
    var classNames = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      classNames[_i] = arguments[_i];
    }
    var result = this.makeCssClassNames.apply(this, classNames).join(" ");
    return result ? result : "";
  };
  Object.defineProperty(HostConfig.prototype, "fontFamily", {
    get: function () {
      return this._legacyFontType.fontFamily;
    },
    set: function (value) {
      this._legacyFontType.fontFamily = value;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(HostConfig.prototype, "fontSizes", {
    get: function () {
      return this._legacyFontType.fontSizes;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(HostConfig.prototype, "fontWeights", {
    get: function () {
      return this._legacyFontType.fontWeights;
    },
    enumerable: false,
    configurable: true
  });
  return HostConfig;
}();
exports.HostConfig = HostConfig;
// eslint-disable-next-line @typescript-eslint/naming-convention
exports.defaultHostConfig = new HostConfig({
  supportsInteractivity: true,
  spacing: {
    small: 10,
    default: 20,
    medium: 30,
    large: 40,
    extraLarge: 50,
    padding: 20
  },
  separator: {
    lineThickness: 1,
    lineColor: "#EEEEEE"
  },
  fontTypes: {
    default: {
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      fontSizes: {
        small: 12,
        default: 14,
        medium: 17,
        large: 21,
        extraLarge: 26
      },
      fontWeights: {
        lighter: 200,
        default: 400,
        bolder: 600
      }
    },
    monospace: {
      fontFamily: "'Courier New', Courier, monospace",
      fontSizes: {
        small: 12,
        default: 14,
        medium: 17,
        large: 21,
        extraLarge: 26
      },
      fontWeights: {
        lighter: 200,
        default: 400,
        bolder: 600
      }
    }
  },
  imageSizes: {
    small: 40,
    medium: 80,
    large: 160
  },
  containerStyles: {
    default: {
      backgroundColor: "#FFFFFF",
      foregroundColors: {
        default: {
          default: "#333333",
          subtle: "#EE333333"
        },
        dark: {
          default: "#000000",
          subtle: "#66000000"
        },
        light: {
          default: "#FFFFFF",
          subtle: "#33000000"
        },
        accent: {
          default: "#2E89FC",
          subtle: "#882E89FC"
        },
        attention: {
          default: "#cc3300",
          subtle: "#DDcc3300"
        },
        good: {
          default: "#028A02",
          subtle: "#DD027502"
        },
        warning: {
          default: "#e69500",
          subtle: "#DDe69500"
        }
      }
    },
    emphasis: {
      backgroundColor: "#08000000",
      foregroundColors: {
        default: {
          default: "#333333",
          subtle: "#EE333333"
        },
        dark: {
          default: "#000000",
          subtle: "#66000000"
        },
        light: {
          default: "#FFFFFF",
          subtle: "#33000000"
        },
        accent: {
          default: "#2E89FC",
          subtle: "#882E89FC"
        },
        attention: {
          default: "#cc3300",
          subtle: "#DDcc3300"
        },
        good: {
          default: "#028A02",
          subtle: "#DD027502"
        },
        warning: {
          default: "#e69500",
          subtle: "#DDe69500"
        }
      }
    },
    accent: {
      backgroundColor: "#C7DEF9",
      foregroundColors: {
        default: {
          default: "#333333",
          subtle: "#EE333333"
        },
        dark: {
          default: "#000000",
          subtle: "#66000000"
        },
        light: {
          default: "#FFFFFF",
          subtle: "#33000000"
        },
        accent: {
          default: "#2E89FC",
          subtle: "#882E89FC"
        },
        attention: {
          default: "#cc3300",
          subtle: "#DDcc3300"
        },
        good: {
          default: "#028A02",
          subtle: "#DD027502"
        },
        warning: {
          default: "#e69500",
          subtle: "#DDe69500"
        }
      }
    },
    good: {
      backgroundColor: "#CCFFCC",
      foregroundColors: {
        default: {
          default: "#333333",
          subtle: "#EE333333"
        },
        dark: {
          default: "#000000",
          subtle: "#66000000"
        },
        light: {
          default: "#FFFFFF",
          subtle: "#33000000"
        },
        accent: {
          default: "#2E89FC",
          subtle: "#882E89FC"
        },
        attention: {
          default: "#cc3300",
          subtle: "#DDcc3300"
        },
        good: {
          default: "#028A02",
          subtle: "#DD027502"
        },
        warning: {
          default: "#e69500",
          subtle: "#DDe69500"
        }
      }
    },
    attention: {
      backgroundColor: "#FFC5B2",
      foregroundColors: {
        default: {
          default: "#333333",
          subtle: "#EE333333"
        },
        dark: {
          default: "#000000",
          subtle: "#66000000"
        },
        light: {
          default: "#FFFFFF",
          subtle: "#33000000"
        },
        accent: {
          default: "#2E89FC",
          subtle: "#882E89FC"
        },
        attention: {
          default: "#cc3300",
          subtle: "#DDcc3300"
        },
        good: {
          default: "#028A02",
          subtle: "#DD027502"
        },
        warning: {
          default: "#e69500",
          subtle: "#DDe69500"
        }
      }
    },
    warning: {
      backgroundColor: "#FFE2B2",
      foregroundColors: {
        default: {
          default: "#333333",
          subtle: "#EE333333"
        },
        dark: {
          default: "#000000",
          subtle: "#66000000"
        },
        light: {
          default: "#FFFFFF",
          subtle: "#33000000"
        },
        accent: {
          default: "#2E89FC",
          subtle: "#882E89FC"
        },
        attention: {
          default: "#cc3300",
          subtle: "#DDcc3300"
        },
        good: {
          default: "#028A02",
          subtle: "#DD027502"
        },
        warning: {
          default: "#e69500",
          subtle: "#DDe69500"
        }
      }
    }
  },
  inputs: {
    label: {
      requiredInputs: {
        weight: Enums.TextWeight.Bolder,
        suffix: " *",
        suffixColor: Enums.TextColor.Attention
      },
      optionalInputs: {
        weight: Enums.TextWeight.Bolder
      }
    },
    errorMessage: {
      color: Enums.TextColor.Attention,
      weight: Enums.TextWeight.Bolder
    },
    debounceTimeInMilliSeconds: 250
  },
  actions: {
    maxActions: 5,
    spacing: Enums.Spacing.Default,
    buttonSpacing: 10,
    showCard: {
      actionMode: Enums.ShowCardActionMode.Inline,
      inlineTopMargin: 16
    },
    actionsOrientation: Enums.Orientation.Horizontal,
    actionAlignment: Enums.ActionAlignment.Left
  },
  adaptiveCard: {
    allowCustomStyle: false
  },
  imageSet: {
    imageSize: Enums.Size.Medium,
    maxImageHeight: 100
  },
  factSet: {
    title: {
      color: Enums.TextColor.Default,
      size: Enums.TextSize.Default,
      isSubtle: false,
      weight: Enums.TextWeight.Bolder,
      wrap: true,
      maxWidth: 150
    },
    value: {
      color: Enums.TextColor.Default,
      size: Enums.TextSize.Default,
      isSubtle: false,
      weight: Enums.TextWeight.Default,
      wrap: true
    },
    spacing: 10
  },
  carousel: {
    maxCarouselPages: 10,
    minAutoplayDuration: 5000
  },
  textBlock: {
    headingLevel: 2
  }
});